import { Descriptions } from 'antd';
import { useIntl } from 'react-intl';

const BatchDescriptions = ({ item }) => {
  const intl = useIntl();
  const commonsProps = {
    colon: false,
    layout: 'vertical',
    column: 5,
    labelStyle: {
      color: '#000000',
      textTransform: 'uppercase',
    },
    contentStyle: { fontSize: '15px', paddingRight: 16 },
  };
  const generalItems = [
    {
      key: 'docket_number',
      label: intl.formatMessage({ id: 'docket_number' }),
      children: item?.docket_number,
    },
    {
      key: 'arriving_date',
      label: intl.formatMessage({ id: 'arriving_date' }),
      children: item?.arriving_date,
    },
    {
      key: 'control_type',
      label: intl.formatMessage({ id: 'control_type' }),
      children: item?.control_type,
    },
    {
      key: 'detailed_location',
      label: intl.formatMessage({ id: 'detailed_location' }),
      children: item?.detailed_location,
    },
    {
      key: 'recipe',
      label: intl.formatMessage({ id: 'recipe' }),
      children: item?.recipe,
    },
  ];

  const renderDescriptions = (items) => (
    <Descriptions {...commonsProps}>
      {items.map(({ key, label, children }) => (
        <Descriptions.Item key={key} label={label}>
          {children}
        </Descriptions.Item>
      ))}
    </Descriptions>
  );

  return renderDescriptions(generalItems);
};

export default BatchDescriptions;
